export * from './project.gql-mutation';
export * from './project.gql-query';
